module.exports = __webpack_public_path__ + "img/viaductos-y-barcazas (3).0dca0954.jpg";